import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-cream" data-id="element-127">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-128">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-130">
            <span className="inline-block py-1 px-3 rounded-full bg-forest/10 text-forest font-semibold text-sm tracking-wide mb-6" data-id="element-131">
              NUEVO PROTOCOLO
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-132">
              El Protocolo de 72 Horas para Desinflamar tu Cuerpo y Recuperar la
              Energía que los 40 te Robaron.
            </h1>
            <p className="text-lg md:text-xl text-charcoal-light mb-8 leading-relaxed" data-id="element-133">
              Apaga el "incendio interno", drena el cortisol acumulado y vuelve
              a abrocharte tus pantalones favoritos en solo 3 días sin dietas
              extremas.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-134">
              <a href="#oferta" onClick={e => {
              e.preventDefault();
              document.getElementById('oferta')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }} className="inline-flex justify-center items-center px-8 py-4 text-lg font-bold text-white bg-amber hover:bg-amber-dark rounded-lg transition-colors duration-200 shadow-premium w-full sm:w-auto" data-id="element-135">
                ¡QUIERO DESINFLAMARME AHORA!
              </a>
            </div>
            <div className="mt-4 flex items-center gap-2 text-sm text-charcoal-light font-medium" data-id="element-136">
              <LockIcon className="w-4 h-4 text-forest" data-id="element-137" />
              <span data-id="element-138">Acceso inmediato · Pago 100% seguro</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:ml-auto" data-id="element-139">
            <div className="relative rounded-2xl overflow-hidden shadow-premium" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/jDUzFyLpZQKXA8WeUmY6hg/heylloyd-image-1779938771738.png" alt="The Inflammatix Reset Mockup" className="w-full h-auto object-cover" data-id="element-141" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};